import AxiosInstance from '../../core/api/axiosinstance'
import { querystring, promiseToResult } from '../../utils'

export interface Language {
  id: number
  code: string
  language: string
  active: boolean
  icon: string
  displayName: string
  countries: string[]
}

export type GetLanguagesRes = Language[]
const getLanguages = () => {
  const query = { limit: 2000 }
  return promiseToResult(AxiosInstance().get<GetLanguagesRes>(
    `/application/languages?${query ? querystring.stringify(query) : ''}`,
  ))
}

export const LanguageAPI = {
  getLanguages,
}
